import { axiosPost } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import Store from 'redux/Store'
import setMessage from 'shared/redux/actions/setMessage'
import displayGenError from 'shared/utils/displayGenError'


const unlockAccount = async (id: number) => {

  await axiosPost(
    apiUrls.superadmins + '/' + id + '/' + apiUrls.actionUnlock,
    {},
    (err: AxiosError) => {
      switch (err.response!.status) {
        case 500:
          Store.dispatch(
            setMessage(err.response!.data?.message ?? 'An error occurred', 'error', 'instant'),
          )
          break
        default:
          displayGenError({ setShowOverlay: () => {} })
      }
      return err.response
    },
  ).then((res) => {
    if (res!.status === 200) {
      const successText =
        'The user account has been unlocked for login.'
      Store.dispatch(setMessage(successText, 'success', 'instant'))
    }
  })
}

export default unlockAccount
